import { translate } from "app/filters/i18nFilter";
import { StyledExportEmptyState, StyledSubTitleExportEmptyState, StyledTitleExportEmptyState } from "./styles";

export const EmptySearchState = () => {
    return (
        <StyledExportEmptyState>
            <StyledTitleExportEmptyState>
                {translate("si.management.sf.settings_export.table.empty_state.title")}
            </StyledTitleExportEmptyState>
            <StyledSubTitleExportEmptyState>
                {translate("si.management.sf.settings_export.table.empty_state.subtitle")}
            </StyledSubTitleExportEmptyState>
        </StyledExportEmptyState>
    );
};
